import { shape, string } from 'prop-types';
import React from 'react';

import ScopedDrawer, { changelog } from '../generic/ScopedDrawer';
import Titled from '../layout/Titled';
import ListCategorizedOpportunities from '../opportunities/ListCategorizedOpportunities';
import { contactShape } from '../prop-types';
import api from '../REST/api';
import AuthorizedLink from '../REST/AuthorizedLink';
import ListContactLists from './contact-lists/ListContactLists/ListContactLists';
import ContactForm from './ContactForm';

const ShowContact = ({ match, model }) => {
  const id = Number.parseInt(match.params.id, 10);
  const hasSalesforceId = !!model.salesforceId;
  return (
    <Titled
      title="Contact"
      actions={
        !hasSalesforceId && (
          <AuthorizedLink
            to="edit"
            className="btn btn-secondary"
            query={api.patchContact}
          >
            Edit
          </AuthorizedLink>
        )
      }
      sticky
    >
      <ScopedDrawer
        options={[changelog({ contentType: 'contact', objectId: id })]}
      >
        <ContactForm id={id} model={model} />
        <div className="mb-4" />
        <ListContactLists titleSize="sm" contactId={id} />
        <ListCategorizedOpportunities
          contactId={id}
          titleSize="sm"
          showCreateLink={false}
        />
      </ScopedDrawer>
    </Titled>
  );
};

ShowContact.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
  model: contactShape.isRequired,
};

export default ShowContact;
